import { ExecutionStatusActionButton } from '../shared/ExecutionStatusActionButton';
import { ExecutionStatus, TransportOrder } from '../transportAssignment.types';
import { DayAndTimePicker } from '../../sharedComponents/DayAndTimePicker';
import { useState } from 'react';
import { useBulkUpdateExecutionStatusForm } from './useBulkUpdateExecutionStatusForm';
import { getIsConfirmed } from '../TransportAssignmentUtils';
import { getTimeZoneOrDefault } from './useBulkUpdateConfirmationForm';

export type BulkUpdateDateInputProps = {
    readonly status: ExecutionStatus;
    readonly assignments: TransportOrder[];
};

export const BulkUpdateExecutionStatusForm = ({ status, assignments }: BulkUpdateDateInputProps) => {
    const { executionDate, validation, setExecutionDate, isLoading, handleExecutionStatusUpdate } =
        useBulkUpdateExecutionStatusForm(assignments, status);

    const statusString = status === ExecutionStatus.LOADED ? 'confirmLoading' : 'confirmUnloading';
    const isButtonDisabled = isLoading || validation.error !== undefined || executionDate === undefined;
    const loadingTimeZone = getTimeZoneOrDefault(assignments.map((assignment) => assignment.loading.timeZone));
    const unloadingTimeZone = getTimeZoneOrDefault(assignments.map((assignment) => assignment.unloading.timeZone));

    const isTransportAssignmentConfirmed = assignments.every((assignment) => getIsConfirmed(assignment));
    const hasLoadedStatus = assignments.some((assignment) =>
        assignment.executionEvents.some((event) => event.eventStatus === ExecutionStatus.LOADED),
    );
    const hasUnloadedStatus = assignments.some((assignment) =>
        assignment.executionEvents.some((event) => event.eventStatus === ExecutionStatus.UNLOADED),
    );

    const [hasInvalidInput, setHasInvalidInput] = useState(false);

    return (
        <div className="display-flex align-items-end flex-row flex-wrap gap-10">
            <div className="flex-1-1 width-60pct min-width-200">
                <DayAndTimePicker
                    labelId={`outboundPortal.transportAssignments.sidebar.executionStatus.${statusString}`}
                    timeZone={status === ExecutionStatus.LOADED ? loadingTimeZone : unloadingTimeZone}
                    date={executionDate}
                    validation={validation}
                    onDateChange={setExecutionDate}
                    isDisabled={isLoading}
                    onParseError={(hasParseError) => setHasInvalidInput(hasParseError)}
                />
            </div>
            <div className="flex-1-1 width-30pct min-width-200">
                <ExecutionStatusActionButton
                    status={status}
                    isTransportAssignmentConfirmed={isTransportAssignmentConfirmed}
                    hasLoadedStatus={hasLoadedStatus}
                    hasUnloadedStatus={hasUnloadedStatus}
                    onClick={handleExecutionStatusUpdate}
                    disabled={isButtonDisabled || hasInvalidInput}
                    isLoading={isLoading}
                />
            </div>
        </div>
    );
};
